<template>
  <div
    v-if="attribute"
    :id="'frequent-attribute-' + container + '-' + attribute.id"
    :class="
      'frequent-filter' +
        (getActiveCategoryAttributeFilters &&
          getActiveCategoryAttributeFilters.nothing == false
          ? ' filled'
          : '') +
        (popoverShown ? ' popover-shown' : '')
    "
    @mouseover="filterMouseOver"
    @mouseleave="filterMouseLeave">
    <img
      v-if="
        (attribute.affects_price == 1 || attribute.affects_time == 1) &&
          !popoverShown
      "
      class="calc-image"
      src="/svg/calc.svg">
    <img
      v-if="
        (attribute.affects_price == 1 || attribute.affects_time == 1) &&
          popoverShown
      "
      class="calc-image"
      src="/svg/calc-white.svg">
    <span
      v-if="attribute.type == 0"
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">{{
        attribute.name +
          (getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.nothing == false
            ? ": " +
              (booleanValue(getActiveCategoryAttributeFilters.yes) ? "Да" : "Нет")
            : "")
      }}</span>
    <span
      v-if="
        (attribute.type == 1 && attribute.view == null) ||
          (attribute.type == 2 && attribute.view == 1)
      "
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">{{
        attribute.name +
          (getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.nothing == false
            ? ": " + getActiveCategoryAttributeFilters.text
            : "")
      }}</span>
    <span
      v-if="
        (attribute.type == 1 && attribute.view == 3) ||
          (attribute.type == 2 && attribute.view == null)
      "
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">{{
        attribute.name +
          (getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.nothing == false
            ? ": " +
              (attribute.availableValues && attribute.availableValues.length > 0
                ? (attribute.availableValues[
                  parseInt(
                    getActiveCategoryAttributeFilters.rangeMultiple.from
                  ) - 1
                ]
                  ? attribute.availableValues[
                    parseInt(
                      getActiveCategoryAttributeFilters.rangeMultiple.from
                    ) - 1
                  ].value
                  : "") +
                  " - " +
                  (attribute.availableValues[
                    parseInt(getActiveCategoryAttributeFilters.rangeMultiple.to) -
                    1
                  ]
                    ? attribute.availableValues[
                      parseInt(
                        getActiveCategoryAttributeFilters.rangeMultiple.to
                      ) - 1
                    ].value
                    : "")
                : getActiveCategoryAttributeFilters.rangeMultiple.from +
                  " - " +
                  getActiveCategoryAttributeFilters.rangeMultiple.to)
            : "")
      }}</span>
    <span
      v-if="attribute.type == 1 && attribute.view == 2"
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">{{
        attribute.name +
          (getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.nothing == false
            ? ": " + getActiveCategoryAttributeFilters.rangeSingle
            : "")
      }}</span>

    <span
      v-if="(attribute.type == 3 && attribute.view != 6) || attribute.type == 4"
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">
      <div
        v-if="
          !getActiveCategoryAttributeFilters ||
            booleanValue(getActiveCategoryAttributeFilters.nothing) == true
        ">
        {{ attribute.name }}
      </div>
      <div
        v-if="
          getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.multiselect &&
            Object.entries(getActiveCategoryAttributeFilters.multiselect).filter(
              (attr) => booleanValue(attr[1]) == true
            ) &&
            Object.entries(getActiveCategoryAttributeFilters.multiselect).filter(
              (attr) => booleanValue(attr[1]) == true
            ).length > 0
        ">
        {{ attribute.name + ":&nbsp;" }}
        <span
          v-for="(value, index) in attribute.availableValues.filter(
            (item) =>
              Object.entries(
                getActiveCategoryAttributeFilters.multiselect
              ).filter(
                (attr) =>
                  booleanValue(attr[1]) == true &&
                  parseInt(item.id) == parseInt(attr[0])
              ).length > 0
          )"
          :key="'multiselect' + index">
          <span
            v-if="
              index <
                attribute.availableValues.filter(
                  (item) =>
                    Object.entries(
                      getActiveCategoryAttributeFilters.multiselect
                    ).filter(
                      (attr) =>
                        booleanValue(attr[1]) == true &&
                        parseInt(item.id) == parseInt(attr[0])
                    ).length > 0
                ).length -
                1 && index < 2
            ">{{ value.value }},&nbsp;</span>
          <span
            v-if="
              index ==
                attribute.availableValues.filter(
                  (item) =>
                    Object.entries(
                      getActiveCategoryAttributeFilters.multiselect
                    ).filter(
                      (attr) =>
                        booleanValue(attr[1]) == true &&
                        parseInt(item.id) == parseInt(attr[0])
                    ).length > 0
                ).length -
                1 && index < 2
            ">{{ value.value }}&nbsp;</span>
        </span>
        <span
          v-if="
            Object.keys(
              Object.entries(
                getActiveCategoryAttributeFilters.multiselect
              ).filter((attr) => booleanValue(attr[1]) == true)
            ).length > 2
          "
          class="more-values">
          ... ({{
            attribute.availableValues.filter(
              (item) =>
                Object.entries(
                  getActiveCategoryAttributeFilters.multiselect
                ).filter(
                  (attr) =>
                    booleanValue(attr[1]) == true &&
                    parseInt(item.id) == parseInt(attr[0])
                ).length > 0
            ).length
          }})</span>
      </div>
    </span>
    <span
      v-if="attribute.type == 3 && attribute.view == 6"
      :id="'frequent-attribute-text' + container + '-' + attribute.id"
      class="attribute-name">{{
        attribute.name +
          (getActiveCategoryAttributeFilters &&
            getActiveCategoryAttributeFilters.nothing == false &&
            attribute.availableValues.filter(
              (item) => item.id == getActiveCategoryAttributeFilters.select
            )[0]
            ? ": " +
              (attribute.availableValues.filter(
                (item) =>
                  parseInt(item.id) ==
                  parseInt(getActiveCategoryAttributeFilters.select)
              )[0]
                ? attribute.availableValues.filter(
                  (item) =>
                    parseInt(item.id) ==
                    parseInt(getActiveCategoryAttributeFilters.select)
                )[0].value
                : "")
            : "")
      }}</span>
    <img
      v-if="
        getActiveCategoryAttributeFilters &&
          getActiveCategoryAttributeFilters.nothing == false
      "
      class="discard-filter"
      src="/svg/close-filter.svg"
      @click="discardAll(true)">
    <b-popover
      v-show="popoverShown"
      :id="'frequent-attribute-popover-' + container + '-' + attribute.id"
      :ref="'frequent-ref-popover-' + container + '-' + attribute.id"
      :target="'frequent-attribute-' + container + '-' + attribute.id"
      :container="container"
      triggers="click"
      placement="bottomleft"
      @shown="showPopover"
      @hidden="popoverShown = false">
      <div class="d-block text-center">
        <div class="popover-head">
          <span class="popover-head-title">{{
            attribute.name.length > 30
              ? getElipsis(attribute.name)
              : attribute.name
          }}</span>
          <img
            src="/svg/close-popover.svg"
            @click="closePopover">
        </div>
        <div
          v-if="attribute.type == 0"
          :key="popoverKey"
          class="popover-attribute-content">
          <div class="custom-control custom-checkbox checkbox">
            <input
              :id="'nothing-' + attribute.id"
              v-model="filters.nothing"
              type="checkbox"
              class="custom-control-input"
              :disabled="
                (filters.yes == false && filters.no == false) || updatingFilters
              "
              @change="checkBoxNothing($event)">
            <label
              :for="'nothing-' + attribute.id"
              class="custom-control-label">(Не выбрано)</label>
          </div>

          <div class="custom-control custom-checkbox checkbox">
            <input
              :id="'yes-' + attribute.id"
              v-model="filters.yes"
              type="checkbox"
              class="custom-control-input"
              :disabled="updatingFilters"
              @change="checkBoxYes($event)">
            <label
              :for="'yes-' + attribute.id"
              class="custom-control-label">Да</label>
          </div>

          <div class="custom-control custom-checkbox checkbox">
            <input
              :id="'no-' + attribute.id"
              v-model="filters.no"
              type="checkbox"
              class="custom-control-input"
              :disabled="updatingFilters"
              @change="checkBoxNo($event)">
            <label
              :for="'no-' + attribute.id"
              class="custom-control-label">Нет</label>
          </div>
        </div>
        <div
          v-if="
            (attribute.type == 1 && attribute.view == null) ||
              (attribute.type == 2 && attribute.view == 1)
          "
          :key="popoverKey"
          class="popover-attribute-content">
          <b-form-input
            v-model="filters.text"
            v-debounce:1s="changeFiltersText"
            :type="attribute.type == 2 ? 'number' : 'text'"
            class="input"/>
        </div>
        <div
          v-if="attribute.type == 1 && attribute.view == 2"
          :key="popoverKey"
          class="popover-attribute-content">
          <b-form-input
            v-model="filters.rangeSingle"
            v-debounce:1s="changeFiltersRangeSingle"
            class="input"/>
        </div>
        <div
          v-if="
            (attribute.type == 1 &&
              attribute.view == 3 &&
              (!attribute.availableValues ||
              attribute.availableValues.length == 0)) ||
              (attribute.type == 2 && attribute.view == null)
          "
          :key="popoverKey"
          class="flex-direction-row popover-attribute-content range-multiple">
          <b-form-input
            v-model="filters.rangeMultiple.from"
            v-debounce:1s="changeRangeMultiple"
            placeholder="от"
            type="number"
            class="input from"/>
          <b-form-input
            v-model="filters.rangeMultiple.to"
            v-debounce:1s="changeRangeMultiple"
            placeholder="до"
            type="number"
            class="input"/>
        </div>
        <div
          v-if="
            attribute.type == 1 &&
              attribute.view == 3 &&
              attribute.availableValues &&
              attribute.availableValues.length > 0
          "
          :key="popoverKey"
          class="flex-direction-row popover-attribute-content">
          <div class="attribute-formula-range">
            <div class="from-select">
              <span>от</span>
              <b-form-select
                v-model="filters.rangeMultiple.from"
                class="range-select"
                @change="changeRangeMultiple">
                <option
                  value=""
                  selected>
                  -
                </option>
                <option
                  v-for="(value, index) in attribute.availableValues"
                  :key="index"
                  :value="index + 1">
                  {{ value.value }}
                </option>
              </b-form-select>
            </div>
            <div class="from-select to-select">
              <span>до</span>
              <b-form-select
                v-model="filters.rangeMultiple.to"
                class="range-select"
                @change="changeRangeMultiple">
                <option
                  value=""
                  selected>
                  -
                </option>
                <template v-for="(value, index) in attribute.availableValues">
                  <option
                    :key="index"
                    :value="index + 1">
                    {{ value.value }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>

        <div
          v-if="
            (attribute.type == 3 && attribute.view != 6) || attribute.type == 4
          "
          class="popover-attribute-content">
          <div class="multiselect-search">
            <b-form-input
              v-model="searchPhrase"
              class="input"
              type="text"
              placeholder="Поиск"/>
          </div>
          <div
            v-show="
              selectedAttributeAvailableValues &&
                selectedAttributeAvailableValues.length > 0
            "
            class="selected-values">
            <div
              v-for="(value, index) in selectedAttributeAvailableValues"
              v-show="
                !searchPhrase ||
                  searchPhrase == '' ||
                  value.value.toLowerCase().indexOf(searchPhrase.toLowerCase()) >
                  -1
              "
              :key="popoverKey + index + 'selected'"
              class="custom-control custom-checkbox checkbox">
              <input
                v-if="filters.multiselect"
                :id="'multiselect-' + value.id"
                v-model="filters.multiselect[parseInt(value.id)]"
                type="checkbox"
                class="custom-control-input"
                :disabled="updatingFilters"
                @change="changeMultiselect()">
              <label
                :for="'multiselect-' + value.id"
                class="custom-control-label">{{ value.value }}</label>
            </div>
          </div>
          <div
            v-for="(value, index) in notSelectedAttributeAvailableValues"
            v-show="
              !searchPhrase ||
                searchPhrase == '' ||
                value.value.toLowerCase().indexOf(searchPhrase.toLowerCase()) > -1
            "
            :key="popoverKey + index + 'notselected'"
            class="custom-control custom-checkbox checkbox">
            <input
              v-if="filters.multiselect"
              :id="'multiselect-' + value.id"
              v-model="filters.multiselect[parseInt(value.id)]"
              type="checkbox"
              class="custom-control-input"
              :disabled="updatingFilters"
              @change="changeMultiselect()">
            <label
              :for="'multiselect-' + value.id"
              class="custom-control-label">{{ value.value }}</label>
          </div>
        </div>
        <div
          v-if="attribute.type == 3 && attribute.view == 6"
          :key="popoverKey"
          class="popover-attribute-select">
          <div
            v-for="(value, index) in attribute.availableValues"
            :key="'select-option' + index"
            class="select-option"
            @click="changeSelect(value.id)">
            {{ value.value }}
          </div>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { parseBool } from "~/services/booleanParser";
import vueDebounce from "vue-debounce";
Vue.use(vueDebounce);
export default {
  components: {
    //calculate
  },
  props: {
    attribute: {
      type: Object,
      default: null,
    },
    container: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      backendUrl: process.env.backendUrl,
      searchPhrase: "",
      getActiveCategoryAttributeFilters: null,
      popoverKey: new Date().toString(),
      element: null,
      awaitingSearch: false,
      mouseOver: false,
      updatingFilters: false,
      popoverShown: false,
      discarding: false,
      filters: {
        nothing: true,
        rangeMultiple: {
          from: "",
          to: "",
        },
        text: null,
        rangeSingle: null,
        select: null,
        multiselect: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      activeCategory: "offerList/getActiveCategory",
    }),
    selectedAttributeAvailableValues() {
      if (!this.filters || !this.filters.multiselect) {
        return null;
      }
      return this.attribute.availableValues.filter(
        (item) => parseBool(this.filters.multiselect[parseInt(item.id)]) == true
      );
    },
    notSelectedAttributeAvailableValues() {
      if (!this.filters || !this.filters.multiselect) {
        return null;
      }
      return this.attribute.availableValues.filter(
        (item) =>
          !this.filters.multiselect[parseInt(item.id)] ||
          parseBool(this.filters.multiselect[parseInt(item.id)]) == false
      );
    },
  },
  created() {
    if (
      (this.attribute.type == 3 && this.attribute.view != 6) ||
      this.attribute.type == 4
    ) {
      this.attribute.availableValues.forEach((item) => {
        this.filters.multiselect[item.id] = false;
      });
    }
    this.setActiveCategoryAttributeFilters();
  },
  mounted() {
    let _this = this;

    document.addEventListener("click", function (event) {
      if (_this.element) {
        var isClickInsideElement = _this.element.contains(event.target);
        if (!isClickInsideElement) {
          _this.closePopover();
        }
      }
    });
  },
  methods: {
    closePopover() {
      if (
        this.$refs[
          "frequent-ref-popover-" + this.container + "-" + this.attribute.id
        ]
      ) {
        this.$refs[
          "frequent-ref-popover-" + this.container + "-" + this.attribute.id
        ].$emit("close");
      }
    },
    async checkBoxNothing(e) {
      if (this.updatingFilters) {
        return;
      }
      if (this.filters.nothing == true) {
        this.filters.yes = false;
        this.filters.no = false;
      }
      await this.updateFilters();
    },
    async checkBoxYes(e) {
      if (this.updatingFilters) {
        return;
      }
      if (parseBool(this.filters.yes)) {
        this.filters.no = false;
        this.filters.nothing = false;
      } else {
        this.filters.nothing = true;
      }
      await this.updateFilters();
    },
    async checkBoxNo(e) {
      if (this.updatingFilters) {
        return;
      }
      if (parseBool(this.filters.no)) {
        this.filters.yes = false;
        this.filters.nothing = false;
      } else {
        this.filters.nothing = true;
      }
      await this.updateFilters();
    },
    async changeFiltersText() {
      if (this.updatingFilters) {
        return;
      }
      if (this.filters.text != "") {
        this.filters.nothing = false;
      } else {
        this.filters.nothing = true;
      }
      await this.updateFilters();
    },
    async changeFiltersRangeSingle() {
      if (this.updatingFilters) {
        return;
      }
      if (this.filters.rangeSingle != "") {
        this.filters.nothing = false;
      } else {
        this.filters.nothing = true;
      }
      await this.updateFilters();
    },
    async changeRangeMultiple() {
      if (this.updatingFilters) {
        return;
      }
      if (
        this.filters.rangeMultiple.from != undefined &&
        this.filters.rangeMultiple.from != "" &&
        this.filters.rangeMultiple.to == ""
      ) {
        if (
          this.attribute.availableValues &&
          this.attribute.availableValues.length > 0
        ) {
          this.filters.rangeMultiple.to = this.attribute.availableValues.length;
        } else {
          this.filters.rangeMultiple.to = "999999";
        }
      }
      if (
        this.filters.rangeMultiple.to &&
        this.filters.rangeMultiple.to != "" &&
        this.filters.rangeMultiple.from == ""
      ) {
        this.filters.rangeMultiple.from = "0";
      }
      if (
        !this.filters.rangeMultiple.from ||
        !this.filters.rangeMultiple.to ||
        this.filters.rangeMultiple.from == "" ||
        this.filters.rangeMultiple.to == ""
      ) {
        this.filters.nothing = true;
      } else {
        this.filters.nothing = false;
      }
      await this.updateFilters();
    },
    async changeMultiselect() {
      if (this.updatingFilters) {
        return;
      }
      let nothing = true;
      Object.keys(this.filters.multiselect).forEach((item) => {
        if (parseBool(this.filters.multiselect[item])) {
          nothing = false;
        }
      });
      if (nothing) {
        this.filters.nothing = true;
      } else {
        this.filters.nothing = false;
      }
      await this.updateFilters();
      this.popoverKey = new Date().toString();
    },
    async changeSelect(id) {
      if (this.updatingFilters) {
        return;
      }
      if (id && id != "") {
        this.filters.select = id;
        this.filters.nothing = false;
      } else {
        this.filters.nothing = true;
      }
      this.closePopover();
      await this.updateFilters();
    },
    async discardAll(update = false) {
      this.discarding = true;
      this.filters = {
        nothing: true,
        rangeMultiple: {
          from: "",
          to: "",
        },
        text: null,
        rangeSingle: null,
        select: null,
        multiselect: {},
      };
      await this.updateFilters(update);
    },
    async updateFilters(update = true) {
      this.updatingFilters = true;
      let filters = this.filters;

      await this.$store.dispatch(
        "offerList/SET_ACTIVE_CATEGORY_ATTRIBUTE_FILTERS",
        {
          id: this.attribute.id,
          filters: {
            yes: filters.yes,
            no: filters.no,
            nothing: filters.nothing,
            text: filters.text,
            rangeSingle: filters.rangeSingle,
            rangeMultiple: {
              from: filters.rangeMultiple ? filters.rangeMultiple.from : null,
              to: filters.rangeMultiple ? filters.rangeMultiple.to : null,
            },
            multiselect: filters.multiselect,
            select: filters.select,
          },
        }
      );
      this.$forceUpdate();
      if (update) {
        this.$parent.$parent.$parent.updateFilters();
      }
    },
    booleanValue(value) {
      return parseBool(value);
    },
    setActiveCategoryAttributeFilters() {
      this.getActiveCategoryAttributeFilters = {
        nothing: true,
        rangeMultiple: {
          from: "",
          to: "",
        },
        text: null,
        rangeSingle: null,
        select: null,
        multiselect: {},
      };
      if (!this.activeCategory || !this.activeCategory.attrs) {
        return;
      }

      let attribute = this.activeCategory.attrs.filter(
        (item) => item.id == this.attribute.id
      )[0];
      if (!attribute || !attribute.filters) {
        this.getActiveCategoryAttributeFilters = {
          nothing: true,
          rangeMultiple: {
            from: "",
            to: "",
          },
          text: null,
          rangeSingle: null,
          select: null,
          multiselect: {},
        };
      } else {
        this.getActiveCategoryAttributeFilters = {
          yes: parseBool(attribute.filters.yes)
            ? parseBool(attribute.filters.yes)
              ? true
              : false
            : false,
          no: parseBool(attribute.filters.no)
            ? parseBool(attribute.filters.no)
              ? true
              : false
            : false,
          nothing: attribute.filters.nothing,
          rangeMultiple: {
            from: attribute.filters.rangeMultiple
              ? attribute.filters.rangeMultiple.from
              : "",
            to: attribute.filters.rangeMultiple
              ? attribute.filters.rangeMultiple.to
              : "",
          },
          text: attribute.filters.text,
          rangeSingle: attribute.filters.rangeSingle,
          select: attribute.filters.select,
          multiselect: attribute.filters.multiselect
            ? JSON.parse(JSON.stringify(attribute.filters.multiselect))
            : {},
          attributesValues: attribute.filters.attributesValues
            ? JSON.parse(JSON.stringify(attribute.filters.attributesValues))
            : {},
        };

        this.getActiveCategoryAttributeFilters = JSON.parse(
          JSON.stringify(this.getActiveCategoryAttributeFilters)
        );
      }

      if (this.getActiveCategoryAttributeFilters) {
        let _this = this;
        Object.keys(this.getActiveCategoryAttributeFilters).forEach((item) => {
          _this.filters[item] = JSON.parse(
            JSON.stringify(_this.getActiveCategoryAttributeFilters[item])
          );
        });
      }
      this.updatingFilters = false;
      this.$forceUpdate();
    },
    updateFiltersKey() {
      this.popoverKey = new Date().toString();
    },
    filterMouseOver() {
      this.mouseOver = true;
    },
    filterMouseLeave() {
      this.mouseOver = false;
    },
    showPopover() {
      this.element = document.getElementById(
        "frequent-attribute-popover-" + this.container + "-" + this.attribute.id
      );
      if (this.discarding) {
        this.$refs[
          "frequent-ref-popover-" + this.container + "-" + this.attribute.id
        ].$emit("close");
        this.discarding = false;
      }
      this.popoverShown = true;
    },
    getElipsis(text) {
      return text.substring(0, 30) + "...";
    },
  },
};
</script>
<style lang="scss" scoped>
.frequent-filter {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 6px 10px 6px 10px;
  white-space: nowrap;
  margin-bottom: 8px;
  margin-right: 8px;
  width: fit-content;
  height: fit-content;

  &:hover {
    background: #f7f9fc;
    .attribute-name {
      color: #2d303a;
    }
  }

  &.popover-shown {
    background: #098aff;
    .attribute-name {
      color: #fff;
    }
  }

  .calc-image {
    margin-right: 8px;
  }

  .discard-filter {
    margin-left: 8px;
  }

  .attribute-name {
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6e7279;
    display: flex;
    white-space: normal;
  }
}

.filled {
  background: #eff1f4;
}

.popover-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 10px;
  border-bottom: solid 2px #eff1f4;
  .popover-head-title {
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #6e7279;
  }
  img {
    cursor: pointer;
  }
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  top: 3px;
}
.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(9, 138, 255, 1);
}
.popover-attribute-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 300px;
  &::-webkit-scrollbar-thumb {
    background-color: #3e4356;
    margin: 5px 0px 5px 0;
    cursor: pointer;
    border: 5px solid rgba(0, 0, 0, 0);
    border-radius: 50px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar {
    height: calc(100% - 10px);
    margin-right: 10px;
    padding-right: 5px;
  }
  .checkbox {
    margin-right: 0;
    margin-bottom: 16px;
    display: flex;
    white-space: nowrap;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .custom-checkbox .custom-control-input ~ .custom-control-label::before {
    cursor: pointer;
  }
  .custom-checkbox .custom-control-input ~ .custom-control-label::after {
    cursor: pointer;
  }

  .custom-control-label {
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #a8aaaf;
    cursor: pointer;
  }
}

.selected-values {
  .custom-control-label {
    color: #2d303a;
  }
}
.range-multiple {
  flex-direction: row !important;
  .from {
    margin-right: 8px;
  }
}
.from-select {
  display: flex;
  align-items: center;
  span {
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 110%;
    color: #a8aaaf;
    margin-right: 12px;
    width: 20px;
  }
}

.selected-values {
  border-bottom: solid 2px #eff1f4;
  padding-bottom: 16px;
  margin-right: -16px;
  margin-left: -16px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 16px;
}

.to-select {
  margin-top: 10px;
}

.more-values {
  color: #a8aaaf;
}

.multiselect-search {
  padding-bottom: 16px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: -16px;
  margin-right: -16px;
  border-bottom: solid 2px #eff1f4;
  margin-bottom: 12px;
}

.popover-attribute-select {
  display: flex;
  flex-direction: column;
  .select-option {
    height: 32px;
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #2d303a;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 7px;
    padding-bottom: 7px;
    cursor: pointer;
  }
  .select-option:hover {
    background: #098aff;
    color: #ffffff;
  }
}
</style>
